import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { LayoutedOverlayFooterColor } from '../layouted-overlay/layouted-overlay.component';

export type InsuranceOverlaySelectionMode = 'select' | 'deselect' | 'disabled' | 'not available';

@Component({
  standalone: false,
  selector: 'ssc-insurance-selection-overlay',
  templateUrl: './insurance-selection-overlay.component.html',
  styleUrls: ['./insurance-selection-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InsuranceSelectionOverlayComponent {
  @Input() public title: string;
  @Input() public subtitle: string;
  @Input() public selectButtonText: string;
  @Input() public selectionMode: InsuranceOverlaySelectionMode = 'select';
  @Input() public price?: number | null;
  @Input() public highlightSelection?: 'primary' | 'supplementary';
  @Input() public mode: 'narrow' | 'wide' = 'narrow';

  @Output() public closed = new EventEmitter<void>();
  @Output() public selected = new EventEmitter<void>();

  public get footerColor(): LayoutedOverlayFooterColor | undefined {
    if (this.highlightSelection === 'primary') {
      return 'yellow';
    }
    if (this.highlightSelection === 'supplementary') {
      return 'violet';
    }
    return undefined;
  }
}
